import { ContainerCardBlueRecepcion } from "./localStyle";

const CardBlueRecepcion = ({ consultorio, medico, piso, centro, isLabo }) => {
  return isLabo ? (
    <ContainerCardBlueRecepcion>
      Tu turno se encuentra recepcionado. Por favor dirigite a la sala de espera
      del <span>{consultorio}</span> en <span>{centro + "."}</span>{" "}
    </ContainerCardBlueRecepcion>
  ) : (
    <ContainerCardBlueRecepcion>
      Tu turno se encuentra recepcionado. Por favor dirigite a la sala de espera
      del <span>{consultorio}</span>, <span>{piso}</span> en{" "}
      <span>{centro}</span>{" "}
      <>
        , donde te llamará el Dr <span>{medico}</span>.
      </>
    </ContainerCardBlueRecepcion>
  );
};
export default CardBlueRecepcion;
